<template>
  <div>
    <div class="w-full fixed md:fit-content top-1.5/10 z-70 center-x px-12 md:px-0">
      <transition-group name="fade">
        <div v-if="message != null" key="normal-notification" class="mb-8">
          <warning-dark
            v-if="type === 'warning-dark'"
            :title="title"
            :items="items"
            :message="message"
            :button-settings="buttonSettings"
            @close="close">
          </warning-dark>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import WarningDark from "./WarningDark.vue";

export default {
  name: 'Notification',

  components: {
    WarningDark
  },

  data () {
    return {
      title: null,
      message: null,
      buttonSettings: {
        type: null,
        href: null,
        text: null,
        displayMobile: false,
      },
      items: [],
      type: 'warning-dark',
      normalNotificationTimeout: null,
    }
  },

  methods: {
    close () {
      this.setData({title: null, message: null, type: null})
    },

    notify (settings) {
      if (this.message !== null) {
        this.setData({title: null, message: null, type: null})
        setTimeout(() => {
          this.setData(settings)
        }, 500)
      } else {
        this.setData(settings)
      }
    },

    setData (data) {
      this.title = data.title
      this.message = data.message
      this.type = data.type ?? 'warning-dark'
      this.items = data.items
      if (data.buttonSettings) {
        this.buttonSettings = {
          type: data.buttonSettings.type ? data.buttonSettings.type : null,
          href: data.buttonSettings.href ? data.buttonSettings.href : null,
          text: data.buttonSettings.text ? data.buttonSettings.text : null,
          displayMobile: data.buttonSettings.displayMobile ?? false,
        }
      }
    }
  },

  mounted() {
    if (document.querySelector('#data-notification')) {
      this.setData(jsonFromPage('#data-notification'))
    }
  },

  watch: {
    message () {
      if  (this.normalNotificationTimeout) {
        clearTimeout(this.normalNotificationTimeout)
      }

      this.normalNotificationTimeout = setTimeout(() => {
        this.setData({title: null, message: null, type: null})
      }, 5000)
    },
  }
}
</script>
